import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Idle from "./pages/Idle.jsx";
import Video from "./pages/Video.jsx";
import Voice from "./pages/Voice.jsx";
import Logo from "./assets/2dlogo.mp4";
// import Logo from "./assets/isuzu_spin_logo.mp4";
import DemoVideoPage from "./pages/DemoVideoPage.jsx";
import PovVideo from "./pages/PovVideo.jsx"

const router = (data) =>
  createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          index: true,
          element: (
            <Idle videoData={data.povVideoData} initialVideo={data.initialVideo} />
          ),
        },
        { path: "povvideo/:id", element: <PovVideo videoData={data.povVideoData} /> },
        // Below ones are not needed anymore
        { path: "video/:id", element: <Video videoData={data.videoData} /> },
        { path: "voice", element: <Voice responseData={data.responseData} /> },
        { path: "demovideo", element: <DemoVideoPage videoData={data.videoData} /> },
      ],
    },
  ]);

function Layout() {
  return (
    <div className="screen-wrapper">
      <div className="screen-container left-container">
        <video
          src={Logo}
          className="logo"
          autoPlay
          loop
          muted
        />
      </div>
      <div className="screen-container right-container">
        <Outlet />
      </div>
    </div>
  );
}

function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("/assets/data.json") // Fetch JSON from public folder
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((jsonData) => {
        setData(jsonData)
      })
      .catch((error) => console.error("Error fetching JSON:", error));
  }, []);

  if (!data) {
    return <div>Loading...</div>;
  }

  return <RouterProvider router={router(data)} />;
}

export default App;
